import React, {Fragment} from "react";
import classes from "classnames";

import pdfSVG from "../../../assets/svg/ils/ils-file-pdf.svg";
import defaultSVG from "../../../assets/svg/ils/ils-file.svg";
import download from "../../../assets/svg/actions/icn-download-16px.svg";
import Carousel, { Modal, ModalGateway } from "react-images";
import Icon from "../Icon";

class ChatMessage extends React.Component {

    state = {
        lightboxIsOpen: false,
        items: [],
        type: null,
        extention: null,
    };

    attachmentType = (attachment) => {
        var type = attachment.type ? attachment.type.replace(/\/.+/g,"") : "";
        var extention = attachment.type ? attachment.type.match(/\/.+/g,"")[0].slice(1) : "";

        switch (type) {
            case "application": {
                return { type: "application", extention: extention, thumps: extention == 'pdf' ? pdfSVG : defaultSVG };
            }; break;
            case "image": {
                return { type: "image", extention: extention, thumps: attachment.base64 };
            }; break;
            default: {
                return { type: "application", extention: extention, thumps: defaultSVG };
            }; break;
        }
    }

    showLightbox = (event, attachment, hasIframe) => {
        event.preventDefault();
        this.setState({
            lightboxIsOpen: true,
            items: [{ source: attachment.base64, caption: attachment.name, iframe: hasIframe }]
        })
    }

    appendThumps = (attachment, attachmentType) => {
        var hasIframe = (attachmentType.type == 'application' && attachmentType.extention == 'pdf');
        var hasLightbox = hasIframe || attachmentType.type == 'image';

        return hasLightbox ? (
            <a href="#" onClick={(event) => this.showLightbox(event, attachment, hasIframe)}>
                <img className="attachment-thumps" src={attachmentType.thumps} alt={attachment.name}/>
            </a>
        ) : (
            <a href="#">
                <img className="attachment-thumps" src={attachmentType.thumps} alt={attachment.name}/>
            </a>
        )
    }

    appendAttachment = (attachment) => {
        var attachmentType = this.attachmentType(attachment);
        return attachment && attachment.base64 ? (
            <Fragment>
                <div className="content">
                    <div className={classes("attachment-wrapper", attachmentType.type)}>
                        {this.appendThumps(attachment, attachmentType)}
                        <a className="attachment-link d-flex align-items-center" href={attachment.base64} download={attachment.name}>
                            <Icon svg={download} className="attachment-download-icon"/>
                            <span className="attachment-name">{attachment.name}</span>
                        </a>
                    </div>
                </div>
                {
                    attachment.message ? (
                        <div className="content">
                            <div className="message-wrapper">
                                <p>{attachment.message}</p>
                            </div>
                        </div>
                    ) : null
                }
            </Fragment>
        ) : null
    }

    appendMessage = (message) => {
        return (
            <div className="content">
                <div className="message-wrapper">
                    <p>{message}</p>
                </div>
            </div>
        )
    }

    appendContent = (data) => {
        if(data.message) {
            return this.appendMessage(data.message);
        } else if(data.attachment) {
            return this.appendAttachment(data.attachment);
        }
    }

    render() {

        return (
            <Fragment>
                {this.messageHtml()}
                {this.lightbox()}
            </Fragment>
        )
    }

    onCloseLightbox = () => {
        this.setState({
            lightboxIsOpen: false,
        })
    }

    lightbox = () => {
        const { lightboxIsOpen, items } = this.state;

        return (
            <ModalGateway>
                {lightboxIsOpen ? (
                    <Modal onClose={this.onCloseLightbox}>
                        <Carousel
                            views={items}
                            components={{
                                View: (props) => {
                                    console.log(props);
                                    var { isModal, currentView } = props;

                                    return isModal ? (
                                        <div>
                                            {
                                                currentView.iframe ? (
                                                    <iframe src={currentView.source} style={{ width: "75vw", height: "75vh" }}/>
                                                ) : (
                                                    <img src={currentView.source} alt={currentView.caption}/>
                                                )
                                            }
                                        </div>
                                    ) : null;
                                }
                            }}
                        />
                    </Modal>
                ) : null}
            </ModalGateway>
        )
    }
};

export default ChatMessage;